import Vue from "vue";
import Constants from '@/core/utils/constants'
import { Util as Utils } from "@wizepe/wizeui"
import * as moment from 'moment';

function decimalFun(el, binding) {
  if (typeof binding.value != 'undefined' && binding.value != null) {
    const formattedValue = Utils.formatNumber(binding.value);
    if (binding.arg) {
      const currency = Constants.Currencies[binding.arg.toUpperCase()]
      el.innerHTML = `${currency} ${formattedValue}`;
    } else
      el.innerHTML = formattedValue
  } else {
    el.innerHTML = null
  }
}

function intFun(el, binding) {
  if (typeof binding.value != 'undefined' && binding.value != null) {
    el.innerHTML = binding.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    el.innerHTML = null
  }
}

function localDateFun(el, binding) {
  if (typeof binding.value != 'undefined' && binding.value != null) {
    el.innerHTML = moment(binding.value).format(binding.arg !== 'hour' ? "DD/MM/YYYY" : "DD/MM/YYYY hh:mm A");
  } else {
    el.innerHTML = "---"
  }
}

function emptyFun(el, binding) {
  if (typeof binding.value != 'undefined' && binding.value != null) {
    el.innerHTML = binding.value;
  } else {
    el.innerHTML = "---"
  }
}

Vue.directive('localDate', {inserted: localDateFun, update: localDateFun});
Vue.directive('int', {inserted: intFun, update: intFun});
Vue.directive('decimal', {inserted: decimalFun, update: decimalFun});
Vue.directive('empty', {inserted: emptyFun, update: emptyFun});
